"use client";

import { jsxs as A, jsx as d } from "react/jsx-runtime";
import i, { useRef as B, useState as _ } from "react";
import { classNames as p } from "../../utilities/index.js";
import "./index.css.js";
const v = _ref => {
    let {
      defaultActiveTab: f = 0,
      justify: t = "center",
      theme: b = "light",
      className: e,
      children: r,
      onTabClick: a
    } = _ref;
    var h, T, x, L;
    const s = B(null),
      [o, m] = _(f),
      u = p({
        "sash-TabsList border-b border-b-gray-40/60 md:border-b-transparent overflow-x-auto mb-4 scroll-smooth list-none m-0 p-0 flex space-x-6 md:space-x-12": !0,
        "before:content-[''] before:m-auto after:content[''] after:m-auto": t === "center",
        [`md:justify-${t}`]: t,
        "sash-TabsList--dark": b === "dark",
        [e]: e
      }),
      g = (l, n) => {
        var k, y, C;
        if (l === o) return;
        const c = (y = (k = s == null ? void 0 : s.current) == null ? void 0 : k.childNodes) == null ? void 0 : y[0],
          w = ((C = n.target) == null ? void 0 : C.offsetLeft) - 50 - (c == null ? void 0 : c.offsetLeft);
        c.scrollLeft = w, m(l), a && a(l);
      };
    return r ? /* @__PURE__ */A("div", {
      className: "sash-TabsListWrapper",
      ref: s,
      children: [((T = (h = i.Children) == null ? void 0 : h.toArray(r)) == null ? void 0 : T.length) > 1 && /* @__PURE__ */d("ul", {
        className: u,
        role: "tablist",
        children: i.Children.toArray(r).map((l, n) => i.cloneElement(l, {
          isActive: n === o,
          key: n,
          _onTabClick: g,
          tabIndex: n,
          theme: b
        }))
      }), /* @__PURE__ */d("div", {
        className: "relative",
        role: "tabpanel",
        children: (L = (x = i.Children) == null ? void 0 : x.toArray(r)) == null ? void 0 : L[o].props.children
      })]
    }) : null;
  },
  N = _ref2 => {
    let {
      title: f,
      theme: t,
      tabIndex: b = 1,
      isActive: e,
      _onTabClick: r,
      className: a,
      ...s
    } = _ref2;
    const o = p({
        "sash-TabItem flex-none": !0,
        "text-white": t === "dark",
        [a]: a
      }),
      m = p({
        "sash-TabBtn block px-2 py-0 font-semibold text-md md:text-lg": !0,
        "sash-TabBtn--active border-b-2 border-b-primary": e,
        "border-b-2 border-b-transparent": !e,
        "text-white": t === "dark"
      });
    return /* @__PURE__ */d("li", {
      className: o,
      children: /* @__PURE__ */d("button", {
        role: "tab",
        "aria-selected": e ? "true" : "false",
        onClick: u => r(b, u),
        className: m,
        ...s,
        children: f
      })
    });
  };
v.Tab = N;
N.displayName = "TabsList.Tab";
const S = v;
export { S as default };